import React from 'react';
import './Boost.css';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

function Support() {
  return (
    <div className='add'>
      <div className='pad boost-container centered-text'>
        <span className='large-text'>
          <TranslateText text="If you've come across a hiccup or delay, let us know using the form below!" />
        </span>
        <span className='large-text'>
          <TranslateText text="Or you can call us, and we will guide you through the support ticket." />
        </span>
        <br />
        <span className='large-text'>
          <TranslateText text="1-855-CLUB-850  (1-855-258-2850)" />
        </span>
        <span className='large-text'>
          <TranslateText text="Ext: 1 for Ariella" />
        </span>
        <span className='large-text'>
          <TranslateText text="Ext: 2 for Adiyah" />
        </span>
        <span className='large-text'>
          <TranslateText text="Ext: 3 for Spanish" />
        </span>

      </div>

      <div className="boost-container">
        <br />
        <span className="large-text">
          <TranslateText text="Hiccups don’t happen often, but when they do, we’re always here to help! " />
        </span>
        <span className="large-text">
          <TranslateText text = "Please submit a support ticket for the following things:" />
        </span>
        <span className="large-text">
          <TranslateText text="1. Help with pulling your tradeline through " />
        </span>
        <span className="large-text">
          <TranslateText text="(NOTE: please ensure you follow the address modification instructions " />
        </span>
        <span className="large-text">
          <TranslateText text="emailed to you about your order. Most tickets we get are from clients not following the instructions  " />
        </span>
        <span className="large-text">
          <TranslateText text= "we initially emailed to them. Check the email you used when you placed the order)" />
        </span>
        <span className="large-text">
          <TranslateText text="2. Report a potential non-posting issue" />
        </span>
        <span className="large-text">
          <TranslateText text="3. Question or comments about your order" />
        </span>
        <span className="large-text">
          <TranslateText text="4. Ask when your tradeline will report" />
        </span>
        <span className="large-text">
          <TranslateText text="5. General technical help with the website or order form" />
        </span>
        <br />
        <br />

        <span className="large-text">
          <TranslateText text="Our response time is quick! You will receive a response the same day in most cases." />
        </span>
        <span className="large-text">
          <TranslateText text="Please note that our office hours are Monday through Friday from 9am to 6pm PST (and off major holidays)." />
        </span>
        <span className="large-text">
          <TranslateText text="We take our customer service super serious and respond back to everyone promptly." />
        </span>
        <span className="large-text"></span>
        <span className="large-text"></span>
        <span className="large-text"></span>
        <span className="large-text"></span>
        <span className="large-text"></span>
        <br />
      </div>
    </div>
  );
}

export default Support;







// import React from 'react'
// import './Boost.css'
// function Support() {
//     return (
//         <div className='add'>
//             <div className='pad boost-container centered-text'>
      
//             <span className='large-text'>If you've come across a hiccup or delay, let us know using the form below!</span>
//             <span className='large-text'> Or you can call us, and we will guide you through the support ticket.  </span>
//             <br></br>
//             <span className='large-text'>1-855-CLUB-850</span>
//             <span className='large-text'>Ext: 1 for Ariella</span>
//             <span className='large-text'>Ext: 2 for Adiyah</span>
//             <span className='large-text'>Ext 3: for Spanish</span>
//             <span className='large-text'>Ext 4: for Business Credit</span>    
//             </div>

//             <div className="boost-container">
//             <br></br>
//             <span className="large-text">Hiccups don’t happen often, but when they do, we’re always here to help! Please submit a support ticket for the following things:</span>
//             <span className="large-text">1. Help with pulling your tradeline through (NOTE: please ensure you follow the address modification instructions emailed to you about your order.</span>
//             <span className="large-text">Most tickets we get are from clients not following the instructions we initially emailed to them. Check the email you used when you placed the order)</span>
//             <span className="large-text">2. Report a potential non-posting issue</span>
//             <span className="large-text">3. Question or comments about your order</span>
//             <span className="large-text">4. Ask when your tradeline will report</span>
//             <span className="large-text">5. General technical help with the website or order form</span>
//             <br></br>
//             <br></br>

//             <span className="large-text">Our response time is quick! You will receive a response the same day in most cases.</span>
//             <span className="large-text">Please note that our office hours are Monday through Friday from 9am to 6pm PST (and off major holidays).</span>
//             <span className="large-text">We take our customer service super serious and respond back to everyone promptly.</span>
//             <span className="large-text"></span>
//             <span className="large-text"></span>
//             <span className="large-text"></span>
//             <span className="large-text"></span>
//             <span className="large-text"></span>
//             <br></br>

//         </div>
//         </div>
//       )
// }

// export default Support
